// extracted by mini-css-extract-plugin
export var banner = "_n9-0";
export var settingRow = "_n9-2";
export var titleIcon = "_n9-1";